import { $d } from 'src/utils';
import triggerEvent from 'src/lib/utils/trigger_event';
import { modifyEventDate } from 'src/cards_event';

const handleSchedulePostContent = (target) => {
  if (!target) { return; }

  const { checked } = target;
  const schedulePostDate = document.querySelector('.js-schedule-post-date');

  schedulePostDate.hidden = !checked;
  $('.js-schedule-post-date :input').attr('disabled', checked ? null : true);
};

$(document)
  .on('cocoon:before-insert', '.js-poll-cocoon, .js-date-cocoon, .js-organize-cocoon', function onCocoonBeforeInsertCardBinder(e, $insertedItem) {
    const priorities = $('.nested-fields-priority [type="number"]', this).map((i, element) => element.value).get();
    priorities.push(0);

    const priority = Math.max.apply(this, priorities);
    $insertedItem.find('.nested-fields-priority [type="number"]').val(priority + 1);

    const $toggleTime = $insertedItem.find('[data-visibility-id="datetime-time"]');
    $toggleTime.length && $toggleTime.toggleClass('d-none', !e.currentTarget.querySelector('[data-visibility-target="datetime-time"]').checked);
  })

  .on('cocoon:before-remove', '.js-poll-cocoon, .js-date-cocoon, .js-organize-cocoon', function onCocoonBeforeRemoveCardBinder(e) {
    const cocoonMin = (e.currentTarget.dataset.cocoonMin ? Number(e.currentTarget.dataset.cocoonMin) : 2);
    if ($('.nested-fields', this).length === cocoonMin) {
      e.preventDefault();
    }
  })

  .on('cocoon:after-remove cocoon:after-insert', '.js-poll-cocoon, .js-date-cocoon, .js-organize-cocoon', function onCocoonAfterCardBinder(e) {
    const cocoonMin = (e.currentTarget.dataset.cocoonMin ? Number(e.currentTarget.dataset.cocoonMin) : 2);
    const $el = $(this);
    const k = 'cocoon-disable-remove';

    $('.nested-fields:visible', this).length <= cocoonMin ? $el.addClass(k) : $el.removeClass(k);
  })

  .on('change', '.js-schedule-post', e => handleSchedulePostContent(e.target))

  .on('ionModalWillPresent', 'body', (e) => {
    handleSchedulePostContent(e.target.querySelector('.js-schedule-post'));
  });

function formDataToJson(formData) {
  const object = {};
  if (!formData) { return object; }

  [...formData.entries()].forEach(([key, value]) => {
    object[key] = value;
  });

  return object;
}

function parseQuery(query) {
  const out = {};

  query.replace('?', '').split('&').forEach((pair) => {
    const [key, value] = pair.split('=');
    value && value.trim() && (out[key] = value);
  });

  return out;
}

App.lastSync = +new Date();
let workerTimeout;
let fails = 0;

function worker(opts = {}) {
  // set in .env file SYNC_WORKER_DISABLED=1 to disable worker
  if (App.config.env.SYNC_WORKER_DISABLED) { return; }

  opts.reset && (fails = 0);
  clearTimeout(workerTimeout);
  if (!App.config.user.id) { return; }
  if (!this.pageIsActive) { return; }
  if (App.isSuspended) { return; }

  const query = {};
  const $queries = $('[data-query-name]');
  const userIdsSet = {};
  document.querySelectorAll('[data-user-status]').forEach((n) => {
    userIdsSet[n.dataset.userStatus] = 1;
  });
  const userIds = Object.keys(userIdsSet);
  const allUsers = userIds.concat([...window.OnlineStatus.all]);

  allUsers.length && (query.online_user_status = [...new Set(allUsers)].join('-'));

  $queries.each(function onEach() {
    const link = this.querySelector('.js-load-before');
    const form = document.querySelector('.js-filter-form-modal');
    const formData = form ? new FormData(form) : new FormData();

    const name = this.dataset.queryName;
    query[name] = $.extend(formDataToJson(formData), link && parseQuery(decodeURIComponent(link.search)));
  });

  const workerId = workerTimeout;

  $.ajax({
    url: '/sync/all.json',
    data: query,
    beforeSend() {
      App.lastSync = +new Date();
    },
  })
    .done((data) => {
      workerId === workerTimeout && triggerEvent(document, 'sync', data);
      fails = 0;
    })
    .fail(() => {
      fails += 1;
    })
    .always((data) => {
      if (data.status === 401) { return; }
      if (fails > 2) { return; }
      workerTimeout = setTimeout(worker, App.config.inTestEnv ? 1000 : 5000);
    });
}

let fullStop = false;

function workerStop() {
  clearTimeout(workerTimeout);
}

function workerFullStop() {
  workerStop();
  fullStop = true;
}

window.workerFullStop = workerFullStop;

function workerStart() {
  if (!fullStop) {
    workerStop();
    workerTimeout = setTimeout(worker, 200);
  }
}

window.workerStart = workerStart;

$(document).on('pusher:connected', () => {
  workerStart({ reset: true });
});

document.addEventListener('turbolinks:load', () => {
  fails = 0;
  workerStart();
});

// Stop sync workers if page is idle
document.addEventListener('visibility', (e) => {
  e.detail.pageIsActive ? workerStart() : workerStop();
});

$(document).on('sync', (e) => {
  const data = e.detail;

  if (data.new_cards_available) {
    setTimeout(() => {
      const ids = $('.card').pluck('id', id => parseInt(id, 10));
      const diff = $(data.new_cards_available).not(ids).get();
      diff.length && $('.js-load-before').removeClass('d-none').addClass('d-block');
    }, 400);
  }

  // Update badgeCount property for xs-main-nav-item
  const communityCards = document.querySelector('.js-community-cards-count');
  const marketplaceCards = document.querySelector('.js-marketplace-cards-count');
  const eventCards = document.querySelector('.js-event-cards-count');

  if (communityCards) communityCards.badgeCount = data.since_last_login_community_cards_count || 0;
  if (marketplaceCards) marketplaceCards.badgeCount = data.since_last_login_marketplace_cards_count || 0;
  if (eventCards) eventCards.badgeCount = data.since_last_login_event_cards_count || 0;
});

$(document)
  .on('card.create.fm', (e, data) => {
    const wrapper = document.querySelector('.js-cards-list');
    const $card = $(data.html).addClass('injected');

    if (!wrapper) {
      // development environment renders comments to denote template name, so we must skip them to get the right html element
      const cardId = $card[0]?.dataset?.id || $card[2]?.dataset?.id;

      // check if we are on cards details page and load the new card
      if (window.location.pathname.match(/\w+_cards\/\d+$/) && cardId) {
        window.Turbolinks.visit(cardId);
        return;
      }
      window.Turbolinks.clearCache();
      window.Turbolinks.visit(window.location);
      return;
    }

    const cardsCount = wrapper?.querySelectorAll('xs-card')?.length || 0;
    if (cardsCount === 0) {
      window.Turbolinks.clearCache();
      window.Turbolinks.visit(window.location);
      return;
    }

    const $firstCard = $('.js-cards-list .card:first');
    const $firstXsCard = $('.js-cards-list xs-card-v2:first');

    modifyEventDate($card.find('.js-event-date')[0]);

    if ($firstCard.length) {
      $firstCard.before($card);
    } else if ($firstXsCard.length) {
      $firstXsCard.before($card);
    } else {
      $('.js-cards-list').append($card);
    }
  })
  .on('card.update.fm', (e, data) => {
    const $originalCard = $d('.card', data.id);
    const $card = $(data.html).addClass('injected');
    $originalCard.hasClass('card-chain-next') && $card.addClass('card-chain-next');
    modifyEventDate($card.find('.js-event-date')[0]);
    $originalCard.replaceWith($card);
  })
  .on('turbolinks:load load_more:done load_before:done', () => {
    const el = document.querySelectorAll('.js-event-date');
    if (!el.length) { return; }

    el.forEach((item) => {
      modifyEventDate(item);
    });
  })
  .on('xs-card-menu-before-remove', (e) => {
    const { target } = e;

    if (target.closest('.js-cards-list').querySelectorAll('xs-card').length === 1) {
      // We still haven't removed the card from dom, so length 1 means we are about to be empty
      window.Turbolinks.clearCache();
      window.Turbolinks.visit(window.location);
      return;
    }

    const card = target.closest('xs-card');

    if (card.classList.contains('card-chain-next')) {
      const next = card.nextElementSibling;
      next.classList.remove('card-smart-collapsed', 'card-chain-prev');
      next.classList.add('card-chain-next');
    }
  });
